<template>
  <div class="header-con">
    <div class="head">
      <div class="head-con w-1200">
        <div class="toHome" @click="goHome">HOME</div>
        <div class="head-right-con">
          <el-dropdown v-if="isSignIn" @command="selectDropdown">
            <i class="el-icon-user user-icon" @click.stop="toMyCenter"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="login">{{ isGuest && !this.hasOrder ? 'Login' : userName }}</el-dropdown-item>
              <el-dropdown-item command="logout">Quit</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-badge :value="productNumber" class="item" type="warning" @click="toShoppingCart">
            <i class="el-icon-shopping-cart-2 shopping-icon"></i>
          </el-badge>
          <span class="cart-btn" @click="toShoppingCart">Cart</span>
        </div>
      </div>
    </div>
    <login v-if="isLogin" :isLogin.sync="isLogin" :isShowUser.sync="isShowUser"/>
  </div>
</template>

<script>
  import Login from './Login'
  import indexApi from '@/api/index/indexApi.js'
  export default {
    components: {
      Login
    },
    name: 'headerMudule',
    data () {
      return {
        isLogin: false,
        isShowUser: -1,
        isSignIn: false,
        mount: '',
        userName: '',
        productNumber: 0,
        isGuest: false,
        hasOrder: false
      }
    },
    created () {
      this.getAccountInfo()
      this.getBuyerCartList()
      this.userName = localStorage.getItem('USER_NAME')
      setTimeout(() => {
        this.isGuest = localStorage.getItem('GUEST_TAG') == '1'
        this.hasOrder = localStorage.getItem('HAS_ORDER') == '1'
      }, 1000)
    },
    watch: {
      $route() {
        this.getAccountInfo()
        this.getBuyerCartList()
      }
    },
    methods: {
      backIndex () {
        this.$router.push({path: '/shoppingCart'})
      },
      toShoppingCart () {
        this.$router.push({path: '/shoppingCart'})
      },
      toMyCenter () {
        this.$router.push({path: '/myorders'})
      },
      selectDropdown (command) {
        if (command === 'logout') {
          indexApi.buyerOut().then(res => {
            if (!res.data.code) {
              this.$emit('logout')
              localStorage.clear()
              sessionStorage.clear()
            }
          })
        } else {
          if (this.isGuest) {
            this.isLogin = true
            this.isShowUser = 1
          }
        }
      },
      getAccountInfo () {
        indexApi.getAccountInfo().then(res => {
          if (!res.data.code) {
            this.isSignIn = true
            this.userName = res.data.data.nickName || res.data.data.loginAccount
            localStorage.setItem('GUEST_TAG', res.data.data.guestTag)
            this.isGuest = res.data.data.guestTag === 1
            localStorage.setItem('USER_NAME', this.userName)
            localStorage.setItem('BUYERID', res.data.data.id)
            localStorage.setItem('HAS_ORDER', res.data.data.orderTag ? 1 : 0)
            this.hasOrder = res.data.data.orderTag
          }
        })
      },
      goHome () {
        location.href = location.origin
      },
      getBuyerCartList () {
        indexApi.getBuyerCartList().then(res => {
          if (!res.data.code) {
            if (res.data.data && res.data.data.records) {
              let shoppingList = res.data.data.records
              let productNumber = 0
              shoppingList.forEach(shop => {
                let productsList = shop.items
                productsList.forEach(products => {
                  if (products) {
                    let productItems = products.productItems
                    productItems.forEach(() => {
                      productNumber ++
                    })
                  }
                })
              })
              this.productNumber = productNumber
            }
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "~assets/style/variable";
  .toHome {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #111111;
    line-height: 25px;
    float: left;
    cursor: pointer;
  }
  .header-con {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    overflow: hidden;
    background: rgba(255,255,255,1);
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);
    .head {
      border-bottom: 1px solid #EAECEE;
      .head-con {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 0;
        .logo {
          width: 206px;
          cursor: pointer;
        }
        .head-right-con {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .user-icon {
            font-size: 16px;
            color: @mainFontColor;
            margin-right: 10px;
          }
          .sign-btn {
            display: inline-block;
            line-height: 14px;
            font-size: 14px;
            color: @mainFontColor;
            padding-right: 10px;
            border-right: 1px solid #33475B;
            cursor: pointer;
          }
          .join-btn {
            display: inline-block;
            line-height: 14px;
            font-size: 14px;
            color: @mainFontColor;
            padding-left: 10px;
            cursor: pointer;
            margin-right: 30px;
          }
          .el-dropdown {
            .el-dropdown-link {
              cursor: pointer;
            }
          }
          .el-badge {
            .el-badge__content {
              padding: 2px 4px 0 4px;
            }
            .shopping-icon {
              font-size: 22px;
              cursor: pointer;
            }
          }
          .cart-btn {
            display: inline-block;
            line-height: 14px;
            font-size: 14px;
            color: @mainFontColor;
            padding-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
